import { isFunction } from '@/util/lang';
import Vue from 'vue';

export default function NextTick(dedupe = false): MethodDecorator {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- using generics in decorator typing is wonky
  return (target, propertyKey, descriptor: TypedPropertyDescriptor<any>) => {
    const method: unknown = descriptor.value;

    if (!isFunction(method)) {
      return;
    }

    if (!dedupe) {
      descriptor.value = async function (this: Vue, ...args: unknown[]) {
        await this.$nextTick();

        return await Promise.resolve(method.apply(this, args));
      };

      return;
    }

    const N = Symbol();

    descriptor.value = async function (this: Vue & { [N]?: number }, ...args: unknown[]) {
      const i = 1 + (this[N] || 0);
      this[N] = i;

      await this.$nextTick();

      if (i !== this[N]) {
        return;
      }

      return await Promise.resolve(method.apply(this, args));
    };
  };
}
